import type { ScalarGuideElement } from '@/types'
import { attributesButtonSchema, type AttributesButton } from './attributes'
import { validate } from '@/helpers/validate'
import { guideButtonHtml } from '@/elements/button/component'
export type { AttributesButton } from './attributes'

export const scalarButton: ScalarGuideElement<
  AttributesButton,
  'scalar-button'
> = {
  name: 'scalar-button',
  tagName: 'scalar-button',
  tiptapName: 'custom_button',

  attributeTransform: (_, attrs) => {
    return validate(attributesButtonSchema, {
      title: typeof attrs.title === 'string' ? attrs.title : '',
      href: typeof attrs.href === 'string' ? attrs.href : '',
      icon:
        typeof attrs.icon === 'string'
          ? attrs.icon
          : typeof (attrs.icon as any)?.src === 'string'
            ? (attrs.icon as any)?.src
            : '',
    })
  },
  render: async (props) => guideButtonHtml(props),
}

export { ScalarButtonVue } from './component'
